import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=406119db"
import script from "./tagInput.vue?vue&type=script&lang=js"
export * from "./tagInput.vue?vue&type=script&lang=js"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=406119db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports